// @ts-nocheck
import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Skeleton,
} from '@mui/material';
import MuiButton from 'pages/ProjectBudget/DayworkDocket/common/Button';
import PropTypes from 'prop-types';
import { useClientStyles } from '../../../Styles';
import useClientAccessDaywork from '../../../hooks/useClientAccessDaywork';
import PreviewPdf from '../../../PreviewPdf/PreviewPdf';
import DOMPurify from 'dompurify';

const TextItem = ({ label, text, loading, isFromDescription }) => {
  const classes = useClientStyles();

  return (
    <Grid container spacing={2} mb={1}>
      <Grid item xl={3} lg={3} md={3} sm={4} xs={6}>
        <Typography variant="subtitle2" className={classes.pdfText}>
          {label}
        </Typography>
      </Grid>
      <Grid item xl={9} lg={9} md={9} sm={8} xs={6}>
        {loading ? (
          <Box width="400px">
            <Skeleton animation="wave" />
          </Box>
        ) : (
          <Typography
            variant="subtitle2"
            className={classes.darkText}
            ml={1}
            sx={isFromDescription ? { whiteSpace: 'pre-wrap' } : ''}
          >
            {isFromDescription ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(text || '-'),
                }}
              />
            ) : (
              text || '-'
            )}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

const PdfDetails = () => {
  const classes = useClientStyles();
  const {
    pdfDataLoading,
    pdfData,
    onDownloadPdf,
    downloadLoadingPdf,
    pdf,
    openModal,
    setOpenModal,
  } = useClientAccessDaywork();
  return (
    <>
      {!pdfDataLoading &&
        pdfData?.length > 0 &&
        pdfData.map((item, index) => (
          <Box key={index} className={classes.pdfCard} p={2}>
            <TextItem
              label="Daywork Docket no."
              text={item?.number}
              loading={pdfDataLoading}
            />
            <TextItem
              label="Project"
              text={` ${
                item?.project_job_id ? `(${item?.project_job_id})` : ''
              } ${item?.project}`}
              loading={pdfDataLoading}
            />
            <TextItem
              label={item?.performed_to ? 'Performed between ' : 'Performed on'}
              text={item?.performed_on_aus}
              loading={pdfDataLoading}
            />
            <TextItem
              label="Area/Work Zone"
              text={item?.work_zone}
              loading={pdfDataLoading}
            />
            <TextItem
              label="Reference #"
              text={item?.reference}
              loading={pdfDataLoading}
            />
            <TextItem
              label="Description of work"
              text={item?.description_of_work}
              loading={pdfDataLoading}
              isFromDescription
            />
          </Box>
        ))}
      <Grid mt={2} display="flex" justifyContent="center">
        <MuiButton
          color="primary"
          variant="contained"
          size="small"
          onClick={onDownloadPdf}
          endIcon={
            downloadLoadingPdf && <CircularProgress size={15} color="inherit" />
          }
          disabled={downloadLoadingPdf}
        >
          Preview Report
        </MuiButton>

        <PreviewPdf
          open={openModal}
          setOpen={setOpenModal}
          downloadLoadingPdf={downloadLoadingPdf}
          pdf={pdf}
        />
      </Grid>
    </>
  );
};

export default PdfDetails;

TextItem.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};
